export default "__VITE_ASSET__BOgS41Zs__"